import { render, staticRenderFns } from "./PriceTable.vue?vue&type=template&id=3beb5181&scoped=true"
import script from "./PriceTable.vue?vue&type=script&lang=js"
export * from "./PriceTable.vue?vue&type=script&lang=js"
import style0 from "./PriceTable.vue?vue&type=style&index=0&id=3beb5181&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3beb5181",
  null
  
)

export default component.exports